/**
 * 로그인 직후 1회, 미검증 기업 계정을 기업검증 화면으로 유도하기 위한 one-shot 플래그.
 *
 * features/auth(LoginView)와 features/business(리다이렉트 훅)가 공유하는 값이라
 * 두 슬라이스가 서로를 import 하지 않도록 중립 계층(shared)에 둔다(순환 방지).
 */
const FLAG_KEY = 'howcost.postLoginVerifyCheck';

/** 로그인 성공 지점에서 호출 — 다음 진입 시 1회 검증 리다이렉트를 예약. */
export function markPostLoginVerificationCheck(): void {
  try {
    sessionStorage.setItem(FLAG_KEY, '1');
  } catch {
    // sessionStorage 불가 환경은 무시(리다이렉트만 생략).
  }
}

/** 예약 플래그가 설정돼 있는지. */
export function hasPostLoginVerificationCheck(): boolean {
  try {
    return sessionStorage.getItem(FLAG_KEY) === '1';
  } catch {
    return false;
  }
}

/** 예약 플래그 소비(1회성). */
export function clearPostLoginVerificationCheck(): void {
  try {
    sessionStorage.removeItem(FLAG_KEY);
  } catch {
    // no-op
  }
}
